// extracted by mini-css-extract-plugin
module.exports = {"duda-integration-page":"DudaIntegrationPage_duda-integration-page__9_3ez","go-to-store-page-button":"DudaIntegrationPage_go-to-store-page-button__1KKk4"};